import { format } from "date-fns";
import Swal from "sweetalert2";
import * as Icons from "heroicons-react";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { Toaster } from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import {
  useDeletePurchaseMutation,
  usePurchaseByDateQuery,
  useUpdatePurchaseMutation,
} from "../../services/purchasApi";
import WareHouseDW from "../Common/CustomSelect/WareHouseDW";
import Header from "../Common/Header/Header";
import LoadingModal from "../Common/Modal/LoadingModal";
import PurchaseView from "../Common/Modal/PurchaseView";
import SideBar from "../Common/SideBar/SideBar";
import { signInUser } from "../Utility/Auth";
import { notify } from "../Utility/Notify";
import "./Purchase.css";
import { useSelector } from "react-redux";
// import { useWarehouseQuery } from "../../services/warehouseApi";

const Purchase = () => {
  const navigate = useNavigate();
    const lang = useSelector((state) => state.languageReducer);
  
  const auth = signInUser();
  const [startDate, setStartDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [endDate, setEndDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [warehouse, setWarehouse] = useState("allWh");
  const [deletePurchas] = useDeletePurchaseMutation();
  const [updatePurchase] = useUpdatePurchaseMutation();
  // const [aamarId, setAamarId] = useState("");
  const { aamarId } = auth;
  // const purchases = usePurchasesQuery();

  const { data, isSuccess, isFetching, isLoading, refetch } =
    usePurchaseByDateQuery({
      startDate,
      endDate,
      warehouse,
      aamarId,
    });
  // console.log("po", data);
  // console.log(warehouse, data);

  const [totalPO, setTotalPO] = useState(0);
  const [show, setShow] = useState(false);

  // const [whName, setWhName] = useState("Warehouse");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [loader, setLoader] = useState(true);
  const handleLoaderClose = () => setLoader(false);

  let i = 1;
  const [purchase, setPurchase] = useState([]);
  const [purchaseView, setPurchaseView] = useState([]);
  useEffect(() => {
    isFetching ? setLoader(true) : setLoader(false);
  }, [data, isLoading, isFetching]);

  useEffect(() => {
    data ? setLoader(false) : setLoader(true);
  }, [data]);

  // console.log("Purchese View", purchaseView);
  useEffect(() => {
    refetch();
  }, [startDate, endDate, warehouse, aamarId]);
  useEffect(() => {
    if (auth?.type === "admin") {
      setWarehouse("allWh");
    } else {
      setWarehouse(auth?.warehouse);
    }
  }, []);
  useEffect(() => {
    data?.length > 0 ? setPurchase(data) : setPurchase([]);
    let total = 0;
    if (data?.length > 0) {
      data.map((po) => {
        if (po.status !== "Canceled") {
          total = total + parseFloat(po.total);
        }
      });
      setTotalPO(total);
    }
  }, [data, isSuccess, isLoading]);

  // useEffect(() => {
  //   isSuccess ? setLoader(false) : setLoader(true);
  // }, [isSuccess]);

  // console.log(loader);

  // useEffect(() => {
  //   refetch();
  // }, [startDate, endDate, warehouse, aamarId]);
  // useEffect(() => {
  //   setAamarId(auth?.aamarId);
  // }, []);

  const deleteHandler = async (id) => {
    const data = { _id: id, status: "Canceled" };
    try {
      const result = await Swal.fire({
        title: "Are you Sure?",
        text: "Delete this Purchase?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        setLoader(true);
        const res = await updatePurchase(data);
        if (res) {
          // TODO::
          notify("Purchase Deleted Successful!", "success");
          // add error hendaler for delete error
          // console.log(res);
        } else {
          // console.log("Delete Operation Canceled by Purchase!");
          return;
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoader(false);
    }
  };

  // console.log("date", new Date(), "MM-dd-yyyy");

  const handlePurchaseView = (id) => {
    // send purchese id to purchese view modal
    setPurchaseView(id);
    setShow(true);
  };
  const handlePurchaseUpdate = (purchase) => {
    if (purchase.status === "Pending") {
      // console.log(purchase._id);
      navigate(`/purchase-update/${purchase._id}`);
    } else {
      notify("This Purchase Can not be Modified", "error");
    }
  };

  const handleOnchangeWareHouseFrom = (e) => {
    if (e.option !== "no-warehouse") {
      setWarehouse(e.option);
    } else {
      setWarehouse("allWh");
    }
    // console.log("handle data:", e);

    // console.log('')
    // refetch();
  };
  return (
    <div>
      <div className="container-fluid ">
        <LoadingModal
          title={"Please Wait"}
          onShow={loader}
          handleClose={handleLoaderClose}
        ></LoadingModal>
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <Header title={lang?.purchase || "Purchase"}></Header>
            <div className="row">
              <div className="col-md-7">
                {/* Sort date range */}
                <div className="d-md-flex mt-2 mb-2 align-items-center gap-2 ">
                  {/* <b>Start:</b> */}
                  <div className="date-picker d-flex mt-2 mb-2 align-items-center gap-2">
                    <DatePicker
                      selected={new Date(startDate)}
                      className="form-control me-2"
                      onChange={(date) =>
                        setStartDate(format(new Date(date), "MM-dd-yyyy"))
                      }
                    />
                    <DatePicker
                      selected={new Date(endDate)}
                      className="form-control"
                      onChange={(date) =>
                        setEndDate(format(new Date(date), "MM-dd-yyyy"))
                      }
                    />
                  </div>
                  <div>
                    {auth?.type === "admin" && (
                      <div
                        className="mt-2 mt-md-0 mb-2 mb-md-0 "
                        style={{
                          width:
                            window.innerWidth >= 1024
                              ? 280
                              : window.innerWidth >= 768
                              ? 280
                              : "100%", // Adjust width based on screen size
                        }}
                      >
                        <WareHouseDW
                          id="warehouse"
                          name="warehouse"
                          handleOnChange={handleOnchangeWareHouseFrom}
                          className="form-control "
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-5 d-flex justify-content-end align-items-start">
                <Link to="/purchase-create" className="btn btn-dark float-end">
                  {lang?.createNewPurchase || "Create New Purchase"}
                </Link>
              </div>

              <div className="col-md-12"></div>
              <div className="col-md-12">
                <div
                  className="table-responsive-sm"
                  // style={{ maxHeight: "400px", overflowY: "auto" }}
                >
                  <table className="table table-striped ">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>PO</th>
                        <th>Date</th>
                        <th>Warehouse</th>
                        <th>Vendor</th>
                        {/* <th>PO By</th> */}
                        <th>Item No</th>
                        <th>Total</th>
                        <th>Status</th>
                        <th className="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {purchase?.length > 0 ? (
                        purchase?.map((purchase) => (
                          <tr key={purchase?._id}>
                            <th>{i++}</th>
                            <td>{purchase?.poNo}</td>
                            <td>
                              {purchase?.createdAt &&
                                format(
                                  new Date(purchase?.createdAt),
                                  "MM/dd/yyyy"
                                )}
                            </td>
                            <td>{purchase?.warehouse?.name}</td>
                            <td>{purchase?.supplier?.company}</td>
                            {/* <td>{purchase?.po_by}</td> */}
                            <td>{purchase?.totalItem}</td>
                            <td>
                              {new Intl.NumberFormat().format(
                                purchase?.total?.toFixed(2)
                              )}
                            </td>
                            <td>{purchase?.status}</td>
                            <td>
                              <Icons.EyeOutline
                                onClick={() =>
                                  handlePurchaseView(purchase?._id)
                                }
                                className="icon-eye me-1"
                                size={20}
                              />
                              {purchase?.status === "Pending" && (
                                <Icons.PencilAltOutline
                                  onClick={() => handlePurchaseUpdate(purchase)}
                                  className="icon-eye me-1"
                                  size={20}
                                />
                              )}
                              {purchase?.status === "Pending" && (
                                <Icons.TrashOutline
                                  className="icon-trash"
                                  onClick={() => deleteHandler(purchase?._id)}
                                  size={20}
                                />
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={9}>No Purchase Found</td>
                        </tr>
                      )}

                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          <b>Grand Total</b>
                        </td>
                        <td>
                          <b>
                            {new Intl.NumberFormat().format(
                              parseFloat(totalPO).toFixed(2)
                            )}
                          </b>
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <Toaster position="bottom-right" />
          </div>
        </div>
      </div>
      <PurchaseView
        show={show}
        handleClose={handleClose}
        purchase={purchaseView}
      ></PurchaseView>
    </div>
  );
};

export default Purchase;
